//import React from 'react';
import React, { useEffect, useState } from "react";
import FaqItem from './FaqItem';
import { Link } from 'react-router-dom';
import { useAuth } from '../../AuthContext'; // Adjust the path as needed
import axios from 'axios';
import Breadcrumb from "../Breadcrumb";
function Faq({ user }) {
  const { auth } = useAuth();
  const [candidateFaqData, setCandidateFaqData] = useState([]);
  const [employerFaqData, setEmployerFaqData] = useState([]);

  useEffect(() => {
    const fetchFaq = async () => {
      try {
         if(auth.isAuthenticated && auth.role === "employer"){
          const response = await axios.get(process.env.REACT_APP_API_URL + `faqs/employerfaq`);
          setEmployerFaqData(response.data);
        }
        else{
          const response = await axios.get(process.env.REACT_APP_API_URL + `faqs/candidatefaq`);
          setCandidateFaqData(response.data);
        }
      }
      catch (error) {
        console.log(error);
      }
    }
    fetchFaq();

  }, []);

// const faqData =
//     auth && auth.isAuthenticated
//       ? auth.role === "employer"
//         ? employerFaqData
//         : candidateFaqData
//       : candidateFaqData;
const faqData =
auth.isAuthenticated && auth.role === "employer"
  ? employerFaqData
  : candidateFaqData;

const faqList = faqData.slice(0, 5);

  return (
    <>

      {/* <div class="site-breadcrumb">
        <div class="container">
          <h2 class="breadcrumb-title">Faq's</h2>
          <ul class="breadcrumb-menu">
            <li><Link to="/">Home</Link></li>
            <li class="active">Faq's</li>
          </ul>
        </div>
        <div class="hero-shape">
          <img 
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"
          class="hero-shape-1" src="assets/img/shape/03.svg" alt="" />
          <img 
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"
          class="hero-shape-2" src="assets/img/shape/05.svg" alt="" />
          <img 
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"
          class="hero-shape-3" src="assets/img/shape/06.svg" alt="" />
          <img 
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"
          class="hero-shape-4" src="assets/img/shape/07.svg" alt="" />
        </div>
      </div> */}
      <Breadcrumb
        title="Faq's"
        path={[
          { label: "Home", href: "/", active: false },
          { label: "Faq's", active: true }
        ]}
      />
      <div class="container py-5">
        <div class="row">
          <div class="col-lg-6">
            <div class="faq-left">
              <div class="faq-img">
                <img 
                loading="lazy"
                role="presentation"
                decoding="async"
                fetchpriority="high"
                src="assets/img/faq/01.jpg" alt="" />
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="faq-right">
              <div class="site-heading mb-3">
                <span class="site-title-tagline">Faq's</span>
                <h2 class="site-title my-3">General <span>frequently</span> asked questions</h2>
              </div>
              {/* <p class="about-text">There are many variations of passages of Lorem Ipsum available,
                                but the majority have suffered alteration in some form by injected.</p> */}
              <div class="mt-3">
                <div className="container my-5">
                  {/* <h1 className="display-4 text-center mb-4">Frequently Asked Questions</h1> */}
                  <div className="card shadow">
                  <div className="card-body">
                      {faqList.map((item) => (
                        <FaqItem key={item.id} item={item} /> // CHANGED: Mapping conditional faqData
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Faq;